import { createSlice } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";

// Auth Slice
const authSlice = createSlice({
    name: "auth",
    initialState: { user: null, token: null },
    reducers: {
        login(state, action) {
            state.user = action.payload.user;
            state.token = action.payload.token;
        },
        logout(state) {
            state.user = null;
            state.token = null;
            storage.removeItem("persist:root");
        },
        updateUser(state, action) {
            if (state.user) {
                state.user = { ...state.user, ...action.payload };
            }
        },
    },
});

export const { login, logout, updateUser } = authSlice.actions;

// Export plain reducer — persistence handled by persistCombineReducers in store/index.js
export default authSlice.reducer;
